import reviewServiceSagas from 'features/review/services/sagas';
import { all } from 'redux-saga/effects';
import shopServiceSagas from 'services/shop/sagas';
export default function* rootSaga() {
  yield all([
    shopServiceSagas(),
    reviewServiceSagas(),
  ]);
}
